module.exports = __webpack_public_path__ + "img/device-back.9d053b45.png";